import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IResetLoginRateLimitingParams {
  systemUserIds?: string[];
}

export interface IResetLoginRateLimitingResult extends IResult {
}

export class ResetLoginRateLimitingRequest extends Request<IResetLoginRateLimitingParams, IResetLoginRateLimitingResult> {
  constructor(params: IResetLoginRateLimitingParams) {
    super('resetLoginRateLimiting', params);
  }
}
